var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bookmark-icon",class:{ bookmarked: _vm.isChecked },on:{"click":function($event){$event.preventDefault();return _vm.toggleBookmark()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }